module.exports = __webpack_public_path__ + "img/success.c574ec76.gif";